import { Typography } from '@mui/material';

const ItineraryText = ({ children, sx = {}, ...props }) => {
  return (
    <Typography
      sx={{
        color: '#000',
        fontFamily: 'Open Sans, sans-serif',
        fontSize: { xs: '13px', sm: '14px', lg: '13px' },
        ...sx,
      }}
      {...props}
    >
      {children}
    </Typography>
  );
};

export default ItineraryText;
